export const noHeaderScreenOptions = {
  animation: 'slide_from_right',
  headerShown: false,
};

export const defaultScreenOptions = {
  headerShown: false,
};
